module.exports = __webpack_public_path__ + "Sailec-Bold.4e3aeac517d018b89c6a.svg";


//////////////////
// WEBPACK FOOTER
// /opt/buildhome/repo/src/assets/fonts/Sailec-Bold/Sailec-Bold.svg
// module id = ../../../../../src/assets/fonts/Sailec-Bold/Sailec-Bold.svg
// module chunks = styles